import { render, staticRenderFns } from "./MenuPermissions.vue?vue&type=template&id=7745b011&scoped=true"
import script from "./MenuPermissions.vue?vue&type=script&lang=js"
export * from "./MenuPermissions.vue?vue&type=script&lang=js"
import style0 from "./MenuPermissions.vue?vue&type=style&index=0&id=7745b011&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7745b011",
  null
  
)

export default component.exports